module.exports = __webpack_public_path__ + "static/business-owner-at-work-mobile.d7170484.webp";